<template>
    <div class="card-section">
      <slot></slot>
    </div>
  </template>

  <style scoped>
  .card-section {
    padding: 1.25rem;
  }
  </style>